import * as Yup from 'yup';

const validationSchema = Yup.object({
    account_holder_name: Yup.string()
        .trim()
        .max(50, 'Must be 50 characters or less')
        .required('Account holder name is required'),
    bank_account_number: Yup.string()
        .trim()
        .matches(/^[+0-9]+$/, 'Invalid bank account number')
        .max(20, 'Invalid bank account number')
        .required('Bank account number is required'),
    bank_name: Yup.string()
        .trim()
        .max(50, 'Must be 50 characters or less')
        .required('Bank name is required'),
    ifsc_code: Yup.string()
        .trim()
        .max(50, 'Must be 50 characters or less')
        .required('IFSC code is required'),
});

export default validationSchema;